import { useLocalSearchParams } from "expo-router";
import { ReportsListItem } from "@src/components/web/ReportsListItem.web";
import { ReportsSection } from "@src/components/web/ReportsSection.web";
import { PATRIOT_TOOL_SECTIONS, patriotToolsHref } from "../routes";
import { PatriotToolsPage } from "../components/PatriotToolsPage";
import { useIsPatriotToolOffered } from "../access";
import { useDirectoryTenantName } from "../hooks/useDirectoryTenantName";

export function PatriotToolsIndexScreen() {
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();
  const isOffered = useIsPatriotToolOffered();
  const tenantName = useDirectoryTenantName()(tenantId);

  return (
    <PatriotToolsPage subtitle="Support tools for a3s and Vision Monitoring's Patriot instance.">
      {PATRIOT_TOOL_SECTIONS.map((section) => (
        <ReportsSection
          key={section.title}
          {...(section.ofTenant && tenantName !== undefined ?
            { title: tenantName, subtitle: "Organisation" }
          : { title: section.title })}
        >
          {section.tools.filter(isOffered).map((tool) => (
            <ReportsListItem
              key={tool.subpath}
              title={tool.title}
              subtitle={tool.description}
              href={patriotToolsHref(tenantId, tool.subpath)}
            />
          ))}
        </ReportsSection>
      ))}
    </PatriotToolsPage>
  );
}
